import type { ReactNode } from 'react';

interface Props {
  titulo: string;
  vazio?: boolean;
  msgVazio?: string;
  altura?: number;
  legenda?: ReactNode;
  children: ReactNode;
}

/** Moldura padrão dos gráficos do Financeiro: título, altura fixa e estado vazio. */
export function CardGrafico({ titulo, vazio, msgVazio = 'Sem dados ainda', altura = 260, legenda, children }: Props) {
  return (
    <div className="bg-white dark:bg-slate-900/40 rounded-xl border border-slate-200 dark:border-slate-700 p-4 flex flex-col">
      <div className="flex items-center justify-between mb-3 gap-2">
        <h3 className="text-sm font-semibold text-slate-700 dark:text-slate-200">{titulo}</h3>
        {legenda}
      </div>
      {vazio ? (
        <div className="flex items-center justify-center text-xs text-slate-400 dark:text-slate-500" style={{ height: altura }}>
          {msgVazio}
        </div>
      ) : (
        <div style={{ height: altura }}>{children}</div>
      )}
    </div>
  );
}
